import request from '@/utils/request'

const informationPreview = {
  name: 'informationPreview',
  state: {
    isInformationPreviewDetailLoading: false,
    informationPreviewDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_INFORMATIONPREVIEW_DETAIL_LOADING: (state, data) => {
      state.isInformationPreviewDetailLoading = data
    },
    SET_MODULES_INFORMATIONPREVIEW_DETAIL_DATA: (state, data) => {
      state.informationPreviewDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryInformationPreviewDetailData({ commit }, id) {
      commit('SET_IS_MODULES_INFORMATIONPREVIEW_DETAIL_LOADING', true)
      commit('SET_MODULES_INFORMATIONPREVIEW_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/informationPreview/informationPreviewDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_INFORMATIONPREVIEW_DETAIL_LOADING', false)
          commit('SET_MODULES_INFORMATIONPREVIEW_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_INFORMATIONPREVIEW_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetInformationPreviewDetailData({ commit }) {
      commit('SET_MODULES_INFORMATIONPREVIEW_DETAIL_DATA', {})
    }
  }
}

export default informationPreview
